import React from 'react';

import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Input,
  MenuItem,
  Divider,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import styled from 'styled-components';
import CriteriaTitle from '../CriteriaTitle';
import SelectCustom from '../SelectCustom';

const CustomExpansionPanel = styled(ExpansionPanel)`
  &&& {
    background: transparent;
    box-shadow: none;
    border-bottom: 1px solid #000;
    border-radius: 0;
    width: 100%;
    font-size: 1rem;
    padding-left: 0.25rem;

    & > div {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

const Name = styled.h3`
  font-size: 16px;
`;

const Req = styled.span`
  font-size: 1.25rem;
  font-weight: bold;
  color: red;
`;

const NameWrapper = styled.div`
  // padding: 0 0 0 4px;
  font-size: 12px;
  font-weight: bold;
`;
const ExpansionPanelSummary1 = styled(ExpansionPanelSummary)`
  min-height: unset !important;
  & > div :first-child {
    margin: 8px 0 !important;
  }
  & > div :nth-child(2) {
    right: -4px !important;
  }
  // padding: 0 0 0 4px;
`;

const divStyle = {
  padding: '0px 0px 24px',
};
class CriteriaGroup extends React.Component {
  state = {
    isOpen: false,
    isCEOpen: false,
    bool: this.props.hasCircularEconomy && this.props.hasCircularEconomy,
  };

  circularEconomy = [
    {
      id: 1,
      letter: 'A',
      header: 'Certification and GWP',
      questions: [
        {
          id: 2,
          number: '1.',
          text: 'Cradle to Cradle Certified™?',
          type: 'select',
        },
        {
          id: 7,
          number: '2.',
          text:
            'Environmental Product Declaration (EPD), Product Environment Profile (PEP) or any Life Cycle Assessment (LCA)?',
          type: 'multiple select',
        },
        {
          id: 12,
          number: '3.',
          text:
            'Able to provide information on Global Warming Potential (GWP) required for Life Cycle Assessment (LCA)?',
          type: 'select',
        },
      ],
    },
    {
      id: 16,
      letter: 'B',
      header: 'Materials and Manufacturing',
      questions: [
        {
          id: 17,
          number: '4.',
          text: 'Request country of manufacture/assembly.',
          type: 'textboxes',
        },
        {
          id: 21,
          number: '5.',
          text: 'Proportion of re-used materials used in manufacturing?',
          type: 'select',
        },
        {
          id: 27,
          number: '6.',
          text: 'Proportion of recycled materials used in manufacturing?',
          type: 'select',
        },
        {
          id: 33,
          number: '7.',
          text:
            'Proportion of the waste material from the manufacturing that is reused?',
          type: 'select',
        },
        {
          id: 39,
          number: '8.',
          text:
            'Proportion of the energy used in the manufacturing from renewable sources?',
          type: 'select',
        },
      ],
    },
    {
      id: 45,
      letter: 'C',
      header: 'Packaging and Delivery',
      questions: [
        {
          id: 46,
          number: '9.',
          text: 'Is packaging reusable, recyclable or compostable?',
          type: 'select',
        },
        {
          id: 50,
          number: '10.',
          text:
            'Does supplier retrieve packing materials from site on delivery?',
          type: 'select',
        },
      ],
    },
    {
      id: 53,
      letter: 'D',
      header: 'Flexibility and Maintenance',
      questions: [
        {
          id: 54,
          number: '11.',
          text:
            'Possible to change the optics and accessories to allow for flexibility for future uses?',
          type: 'select',
        },
        {
          id: 59,
          number: '12.',
          text: 'Can luminaire LED engine and driver be replaced?',
          type: 'select',
        },
        {
          id: 64,
          number: '13.',
          text:
            'Can LED engine and driver gear be re-fitted in situ or only in factory?',
          type: 'select',
        },
        {
          id: 69,
          number: '14.',
          text:
            'What needs to be replaced with LED engine to maintain equivalent performance?',
          type: 'select',
        },
        {
          id: 73,
          number: '15.',
          text: 'What tools are needed to replace luminaire components?',
          type: 'select',
        },
        {
          id: 78,
          number: '16.',
          text:
            'Is photometric and colour performance of replacement LEDs guaranteed?',
          type: 'select',
        },
        {
          id: 82,
          number: '17.',
          text:
            'Is there a spares regime for this luminaire that will allow replacement of components over a period of years?',
          type: 'select',
        },
      ],
    },
    {
      id: 87,
      letter: 'E',
      header: 'Monitoring',
      questions: [
        {
          id: 88,
          number: '18.',
          text:
            'Does luminaire record the operating / burning hours electronically?',
          type: 'select',
        },
        {
          id: 93,
          number: '19.',
          text:
            'Does luminaire include a ‘luminaire logbook’ to prove year of manufacture, operating history and/or performance data?',
          type: 'select',
        },
        {
          id: 98,
          number: '20.',
          text: 'Does luminaire have the means to update firmware and logging?',
          type: 'select',
        },
      ],
    },
    {
      id: 103,
      letter: 'F',
      header: 'End-of-life',
      questions: [
        {
          id: 104,
          number: '21.',
          text: 'Can the luminaire be dismantled (and reassembled)?',
          type: 'select',
        },
        {
          id: 109,
          number: '22.',
          text:
            'Can all materials used in the manufacture of the luminaire be recycled and returned to the materials reservoir?',
          type: 'select',
        },
      ],
    },
  ];

  colapse = () => {
    if (this.props.children) {
      this.setState({ isOpen: !this.state.isOpen });
    } else {
      this.setState({ isCEOpen: !this.state.isCEOpen });
    }
  };

  componentDidMount() {
    if (this.props.hasCircularEconomy) {
      this.setState({ bool: this.props.hasCircularEconomy });
    }
    if (this.props.ticketData) {
      let tempTicketData = this.props.ticketData;

      let tempGrandparentId = tempTicketData.criteriaValues.map(
        value => value.grandparentId
      );
      let tempTicketId = tempTicketData.criteriaValues.map(
        value => value.child
      );

      for (let i = 0; i < tempTicketId.length; i++) {
        if (tempGrandparentId.includes(this.props.id)) {
          this.setState({ isOpen: this.props.isEdit });
        }
        for (let j = 0; j < this.props.childId.length; j++) {
          if (tempTicketId.includes(this.props.childId[j])) {
            this.setState({ isOpen: this.props.isEdit });
          }
        }
      }
    }
  }

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   if (this.props !== nextProps) {
  //     this.setState({ isCEOpen: this.props.hasCircularEconomy });
  //     console.log('componentWillReceiveProps', nextProps);
  //   }
  // }

  render() {
    const {
      isCrtiteriaTitle,
      isEdit,
      required = false,
      handleQuestions,
      requiredQ,
      questions,
      ticketData,
      id,
      childId,
      hasCircularEconomy,
    } = this.props;
    //Prenesi iz CETicket iz ticketId endpoint-a u props preko GenericComponent niz grandparent ID-a koji ces da stavis kao uslov da this.state.IsOpen predje u true unutar componentDidMount!!!
    // Takodje dovesti Id za svaku komponentu koja prodje ovde kao Expansion panel u props kako bi imao sa cim da uporedis, ako to nece uporedi stringove, tj name, koji vec imas uvezen, al nije pametno
    return (
      <CustomExpansionPanel
        defaultExpanded={isEdit}
        expanded={this.props.children ? this.state.isOpen : this.state.isCEOpen}
        onChange={this.colapse}
        key={hasCircularEconomy}
      >
        <ExpansionPanelSummary1 expandIcon={<ExpandMore />}>
          <NameWrapper>
            {!isCrtiteriaTitle ? (
              this.props.name + ':'
            ) : (
              <Name>
                {this.props.name}
                {required && <Req>*</Req>}
              </Name>
            )}
          </NameWrapper>
        </ExpansionPanelSummary1>
        <ExpansionPanelDetails style={divStyle}>
          {this.props.children ? (
            this.props.children
          ) : (
            <div>
              {this.circularEconomy.map(item => (
                <div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'baseline',
                      justifyContent: 'space-between',
                      padding: '0.8em 0',
                      fontWeight: 'bold',
                      fontStyle: 'italic',
                    }}
                  >
                    <span>{item.letter}.</span>
                    <span style={{ display: 'inline-block', width: '93%' }}>
                      {item.header}
                    </span>
                  </div>
                  <p>
                    {item.questions.map((child, index) => (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'baseline',
                          justifyContent: 'space-between',
                          paddingBottom: '0.4em',
                        }}
                      >
                        <span>{child.number}</span>
                        <span style={{ display: 'inline-block', width: '93%' }}>
                          {child.text}
                        </span>
                      </div>
                    ))}
                  </p>
                  <SelectCustom
                    style={{ padding: '0.4em 0' }}
                    disableUnderline={true}
                    value={requiredQ[item.id]}
                    onChange={event => handleQuestions(event, item.id)}
                    variant="outlined"
                    defaultValue={requiredQ[item.id]}
                  >
                    <MenuItem
                      // key={} data-name={}
                      value={9999}
                    >
                      Not Set
                    </MenuItem>
                    <MenuItem
                      // key={} data-name={}
                      value={item.id}
                    >
                      Require manufacturer to answer these questions
                    </MenuItem>
                  </SelectCustom>
                  <Divider className="u-mrg-top-10 u-mrg-bot-10" />
                </div>
              ))}
            </div>
          )}
        </ExpansionPanelDetails>
      </CustomExpansionPanel>
    );
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      this.setState({
        isCEOpen:
          this.props.questions && this.props.questions.length > 0 && true,
      });
    }
    if (prevProps.isEdit !== this.props.isEdit) {
      this.setState({ isOpen: this.props.isEdit });
    }
  }
}

export default CriteriaGroup;
